"use client";
import { jsx as a } from "react/jsx-runtime";
import { visuallyHidden as e } from "../../common/styles/mixins/visuallyHidden.js";
import o from "@emotion/styled";
import { forwardRef as t } from "react";
const d = t(
  ({ children: i, ...l }, s) => /* @__PURE__ */ a(n, { ...l, "data-comp": "visually-hidden", ref: s, children: i })
);
d.displayName = "VisuallyHidden";
const u = d, n = o.span`
	${e};
`;
export {
  u as default
};
